import React from 'react'

interface JpIconProps extends React.SVGProps<SVGSVGElement> {
  title?: string
}

export const JpIcon = (props: JpIconProps) => {
  return (
    <svg
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>{props?.title}</title>
      <g clipPath="url(#clip0_12114_94504)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M-4 1.19922H26.0003V21.2003H-4V1.19922Z"
          fill="white"
        />
        <path
          d="M10.9975 42.286C28.1644 42.286 42.0809 28.3695 42.0809 11.2026C42.0809 -5.96433 28.1644 -19.8809 10.9975 -19.8809C-6.16942 -19.8809 -20.0859 -5.96433 -20.0859 11.2026C-20.0859 28.3695 -6.16942 42.286 10.9975 42.286Z"
          fill="#D30000"
        />
      </g>
      <path
        d="M11 0.699219C16.799 0.699219 21.5 5.40023 21.5 11.1992C21.5 16.9982 16.799 21.6992 11 21.6992C5.20101 21.6992 0.5 16.9982 0.5 11.1992C0.5 5.40023 5.20101 0.699219 11 0.699219Z"
        stroke="#D6D8DC"
      />
      <defs>
        <clipPath id="clip0_12114_94504">
          <path
            d="M1 11.1992C1 5.67637 5.47715 1.19922 11 1.19922C16.5228 1.19922 21 5.67637 21 11.1992C21 16.7221 16.5228 21.1992 11 21.1992C5.47715 21.1992 1 16.7221 1 11.1992Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
